import React from 'react';
import {
  Typography, Divider, Row, Col, Input, Card, Button,
} from 'antd';
import {
  PhoneOutlined, LinkedinOutlined, InstagramOutlined,
  FacebookOutlined, YoutubeOutlined, GlobalOutlined,
  UserOutlined, PlusOutlined, WhatsAppOutlined, MailOutlined, EnvironmentOutlined,
} from '@ant-design/icons';

const { Title, Text } = Typography;

const TARJETA_VACIA = {
  titulo: '',
  nombre: '',
  especialidad: '',
  direccion: '',
  telefono: '',
  email: '',
  linkedin: '',
  instagram: '',
};

const MAX_TARJETAS = 6;

const ContactoTab = ({ config, onChange }) => {
  const tarjetas = config.contacto_tarjetas || [];

  const setTarjetas = (nuevas) => onChange('contacto_tarjetas', nuevas);

  const handleTarjetaChange = (idx, field, value) => {
    const copia = tarjetas.map((t, i) => i === idx ? { ...t, [field]: value } : t);
    setTarjetas(copia);
  };

  const agregarTarjeta = () => {
    if (tarjetas.length >= MAX_TARJETAS) return;
    setTarjetas([...tarjetas, { ...TARJETA_VACIA }]);
  };

  const eliminarTarjeta = (idx) => {
    setTarjetas(tarjetas.filter((_, i) => i !== idx));
  };

  const handleRedGeneral = (campo, valor) => {
    onChange(campo, valor);
  };

  const inputStyle = { marginBottom: 8 };

  return (
    <div>

      {/* ── TARJETAS DE CONTACTO ── */}
      <div style={{ marginBottom: 24 }}>
        <Title level={5} style={{ marginBottom: 4 }}>Tarjetas de contacto</Title>
        <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
          Agregá hasta {MAX_TARJETAS} contactos. Solo las tarjetas con datos aparecerán en el micrositio.
        </Text>

        <Row gutter={[16, 16]}>
          {tarjetas.map((t, idx) => (
            <Col xs={24} md={12} key={idx}>
              <Card
                size="small"
                title={
                  <span style={{ fontSize: 13 }}>
                    Tarjeta {idx + 1}{t.nombre ? ` — ${t.nombre}` : ''}
                  </span>
                }
                extra={
                  <Button
                    type="text"
                    danger
                    size="small"
                    onClick={() => eliminarTarjeta(idx)}
                  >
                    Eliminar
                  </Button>
                }
                styles={{ body: { paddingBottom: 8 } }}
              >
                <Input
                  style={inputStyle}
                  placeholder="Título de la tarjeta (ej: Ventas)"
                  value={t.titulo}
                  onChange={e => handleTarjetaChange(idx, 'titulo', e.target.value)}
                />
                <Input
                  style={inputStyle}
                  prefix={<UserOutlined style={{ color: '#bbb' }} />}
                  placeholder="Nombre completo"
                  value={t.nombre}
                  onChange={e => handleTarjetaChange(idx, 'nombre', e.target.value)}
                />
                <Input
                  style={inputStyle}
                  placeholder="Especialidad / cargo"
                  value={t.especialidad}
                  onChange={e => handleTarjetaChange(idx, 'especialidad', e.target.value)}
                />
                <Input
                  style={inputStyle}
                  prefix={<EnvironmentOutlined style={{ color: '#bbb' }} />}
                  placeholder="Dirección / Oficina"
                  value={t.direccion}
                  onChange={e => handleTarjetaChange(idx, 'direccion', e.target.value)}
                />
                <Input
                  style={inputStyle}
                  prefix={<PhoneOutlined style={{ color: '#bbb' }} />}
                  placeholder="Teléfono / WhatsApp"
                  value={t.telefono}
                  onChange={e => handleTarjetaChange(idx, 'telefono', e.target.value)}
                />
                <Input
                  style={inputStyle}
                  prefix={<MailOutlined style={{ color: '#bbb' }} />}
                  placeholder="Email de contacto"
                  value={t.email}
                  onChange={e => handleTarjetaChange(idx, 'email', e.target.value)}
                />
                <Input
                  style={inputStyle}
                  prefix={<LinkedinOutlined style={{ color: '#0a66c2' }} />}
                  placeholder="URL LinkedIn"
                  value={t.linkedin}
                  onChange={e => handleTarjetaChange(idx, 'linkedin', e.target.value)}
                />
                <Input
                  style={{ ...inputStyle, marginBottom: 0 }}
                  prefix={<InstagramOutlined style={{ color: '#e1306c' }} />}
                  placeholder="Usuario Instagram (sin @)"
                  value={t.instagram}
                  onChange={e => handleTarjetaChange(idx, 'instagram', e.target.value)}
                />
              </Card>
            </Col>
          ))}

          {tarjetas.length < MAX_TARJETAS && (
            <Col xs={24} md={12}>
              <Card
                size="small"
                style={{
                  border: '2px dashed #d9d9d9',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: 260,
                  background: '#fafafa',
                }}
                styles={{ body: { width: '100%', textAlign: 'center', padding: 32 } }}
                onClick={agregarTarjeta}
              >
                <PlusOutlined style={{ fontSize: 24, color: '#bbb', marginBottom: 8, display: 'block' }} />
                <Text type="secondary">Agregar tarjeta</Text>
                <br />
                <Text type="secondary" style={{ fontSize: 11 }}>
                  {tarjetas.length}/{MAX_TARJETAS} tarjetas
                </Text>
              </Card>
            </Col>
          )}
        </Row>
      </div>

      <Divider />

      {/* ── REDES SOCIALES GENERALES ── */}
      <div>
        <Title level={5} style={{ marginBottom: 4 }}>Redes sociales de la cabaña</Title>
        <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
          Se muestran antes del footer en la página de contacto.
        </Text>

        <Row gutter={[16, 12]}>
          <Col xs={24} md={12}>
            <Text style={{ fontSize: 12, display: 'block', marginBottom: 4 }}>Instagram</Text>
            <Input
              prefix={<InstagramOutlined style={{ color: '#e1306c' }} />}
              placeholder="usuario (sin @)"
              value={config.contacto_instagram || ''}
              onChange={e => handleRedGeneral('contacto_instagram', e.target.value)}
            />
          </Col>
          <Col xs={24} md={12}>
            <Text style={{ fontSize: 12, display: 'block', marginBottom: 4 }}>Facebook</Text>
            <Input
              prefix={<FacebookOutlined style={{ color: '#1877f2' }} />}
              placeholder="URL o nombre de página"
              value={config.contacto_facebook || ''}
              onChange={e => handleRedGeneral('contacto_facebook', e.target.value)}
            />
          </Col>
          <Col xs={24} md={12}>
            <Text style={{ fontSize: 12, display: 'block', marginBottom: 4 }}>YouTube</Text>
            <Input
              prefix={<YoutubeOutlined style={{ color: '#ff0000' }} />}
              placeholder="URL canal"
              value={config.contacto_youtube || ''}
              onChange={e => handleRedGeneral('contacto_youtube', e.target.value)}
            />
          </Col>
          <Col xs={24} md={12}>
            <Text style={{ fontSize: 12, display: 'block', marginBottom: 4 }}>LinkedIn</Text>
            <Input
              prefix={<LinkedinOutlined style={{ color: '#0a66c2' }} />}
              placeholder="URL perfil o empresa"
              value={config.contacto_linkedin || ''}
              onChange={e => handleRedGeneral('contacto_linkedin', e.target.value)}
            />
          </Col>
          <Col xs={24} md={12}>
            <Text style={{ fontSize: 12, display: 'block', marginBottom: 4 }}>X (Twitter)</Text>
            <Input
              prefix={<GlobalOutlined style={{ color: '#000' }} />}
              placeholder="usuario (sin @)"
              value={config.contacto_twitter || ''}
              onChange={e => handleRedGeneral('contacto_twitter', e.target.value)}
            />
          </Col>
          <Col xs={24} md={12}>
            <Text style={{ fontSize: 12, display: 'block', marginBottom: 4 }}>WhatsApp</Text>
            <Input
              prefix={<WhatsAppOutlined style={{ color: '#25d366' }} />}
              placeholder="Número con código de país (ej: 5491122334455)"
              value={config.contacto_whatsapp || ''}
              onChange={e => handleRedGeneral('contacto_whatsapp', e.target.value)}
            />
          </Col>
        </Row>
      </div>

    </div>
  );
};

export default ContactoTab;
